import { Component, PropTypes } from 'react';
import Clock from 'scripts/components/Clock';
import Weather from 'scripts/components/Weather';
import moment from 'moment-timezone/moment-timezone';
import { timezone, forecast, useCelsius } from 'scripts/config';
import { startTracking } from 'scripts/utils';
import styles from 'styles/chrome';

export default class Chrome extends Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.node),
			PropTypes.node
		]).isRequired
	}

	componentWillMount() {
		const timezoneName = timezone.split('|')[0];

		// Add required timezone data into lib
		moment.tz.add(timezone);
		moment.tz.setDefault(timezoneName);
	}

	componentDidMount() {
		startTracking(this.refs.chrome, this.props.children.props.display);
	}

	render() {
		return (
			<div ref="chrome" className={styles.wrapper}>
				<div className={styles.panels}>
					<Clock />
					<Weather forecast={forecast} useCelsius={useCelsius} />
				</div>

				{this.props.children}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./scripts/components/Chrome.es6
 **/